module.exports = __webpack_public_path__ + "static/img/aRZ_pic03.85c8c0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic03.jpg
// module id = mzxt
// module chunks = 5